import {
    SET_CREDIT_CARD_BANNER_DATA,
    GET_CREDIT_CARD_BANNER_DATA_ERROR,
} from '../actionTypes/CreditCardBannerDataActionTypes';

function CreditCardBannerReducer(state = {}, action) {
    switch (action.type) {
        case SET_CREDIT_CARD_BANNER_DATA:
            return action.content;
        case GET_CREDIT_CARD_BANNER_DATA_ERROR:
            return action.errorHandlerInfo;
        default:
            return state;
    }
}

export default CreditCardBannerReducer;
